import Vue from 'vue'
import Router from 'vue-router'
import home from '../pages/home.vue'
import about from '../pages/about.vue'
import develop from '../pages/develop.vue'
import friend from '../pages/friend.vue'
import myimage from '../pages/myimage.vue'
import advantage from '../pages/advantage.vue'
import brief from '../pages/brief.vue'
import taxation from '../pages/taxation.vue'
import chain from '../pages/chain.vue'
import contact from '../pages/contact.vue'
import news from '../pages/news.vue'
import newsdetail from '../pages/newsdetail.vue'
import mymap from '../pages/mymap.vue'
import download from '../pages/download.vue'
import applicationDetails from '../pages/applicationDetails.vue'

Vue.use(Router)



export default new Router({
  routes: [
	{
		path: '/',
		name: 'home',
		component: home,
		redirect:'/home',
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/home',
		name: 'home',
		component: home,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/about',
		name: 'about',
		component: about,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/develop',
		name: 'develop',
		component: develop,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/friend',
		name: 'friend',
		component: friend,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/myimage',
		name: 'myimage',
		component: myimage,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/advantage',
		name: 'advantage',
		component: advantage,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/brief',
		name: 'brief',
		component: brief,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/taxation',
		name: 'taxation',
		component: taxation,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/chain',
		name: 'chain',
		component: chain,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/contact',
		name: 'contact',
		component: contact,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/news',
		name: 'news',
		component: news,
		meta: {
			keepAlive: true,
		},
	},
	{
		path: '/newsdetail',
		name: 'newsdetail',
		component: newsdetail,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/mymap',
		name: 'mymap',
		component: mymap,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/download',
		name: 'download',
		component: download,
		meta: {
			keepAlive: false,
		},
	},
	{
		path: '/applicationDetails/:type',
		name: 'applicationDetails',
		component: applicationDetails,
		meta: {
			keepAlive: false,
		},
	},
  ],
  
  scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
          return savedPosition
      }
      return {
          x: 0,
          y: 0
      }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js